import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
    height: fit-content;
    text-align: center;
    padding: 20px 40px;

    h1{
        margin: 20px auto;
    }

    h4{
        font-size: 2.5rem;
        color: #b8b7b7;
        margin: 20px auto;
    }

    p{
        font-size: clamp(1.1rem, 2.5vw, 1.2rem);
        span{
            font-weight: bold;
        }
    }
`